import styled from 'styled-components'
import { BP } from 'resources/constants'
import { buttonPrimary } from 'app/sofia/resources/theme/css'
import CaretSvg from 'resources/svg/icons/caret-right.svg'

export const PageWrapper = styled.div`
  .btn {
    ${buttonPrimary};
    background: ${props => props.theme.productSelector.landingAccent} !important;
    border-color: ${props => props.theme.productSelector.landingAccent} !important;
    border-radius: 5px;

    &:hover,
    &:focus {
      background: ${props => props.theme.productSelector.reviewColorDark} !important;
      border-color: ${props => props.theme.productSelector.reviewColorDark} !important;
    }

    &-lg {
      padding: 0 50px;

      @media (min-width: ${BP.md.min}) {
        font-size: 26px;
        padding: 24px 40px;
        font-weight: ${props => props.theme.font.default.bold};
      }

      > span {
        line-height: 1.5;
      }

      &::after {
        content: '';
        margin-left: 12px;
        width: 11px;
        height: 16px;
        background: url(${CaretSvg}) no-repeat center;
        background-size: 8px;
        filter: invert(100%) sepia(1%) saturate(7494%) hue-rotate(273deg) brightness(103%) contrast(97%);
        display: inline-block;
      }
    }
  }
`
